import "./CSS/genericDrawer.scss";
import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import classNames from "classnames";
import {
  SearchSelectors,
  UserContextSelectors
} from "../../redux/selectors/index.js";
import { DrawerType } from "../../constants/index.js";
import { useBottomBar, useNonReactElementExist } from "../../hooks/index.js";

const showBackBtnMenus = [DrawerType.HamburgerMenu, DrawerType.MyAccountArea];

const GenericDrawer = props => {
  const {
    header,
    className,
    children,
    isVisible,
    menu,
    componentRef,
    verticalTransition
  } = props;

  const isMobile = useSelector(UserContextSelectors.isMobile);
  const searchActive = useSelector(SearchSelectors.searchActive);
  const [topSectionClass, setTopSectionClass] = useState("");
  const [drawerPaddingBottom, setDrawerPaddingBottom] = useState(0);
  const { isDisplayedButtonBar } = useBottomBar();

  useEffect(() => {
    setTopSectionClass(
      classNames({
        showBackBtn: !showBackBtnMenus.includes(menu) || searchActive
      })
    );
  }, [menu, searchActive]);

  const headerClasses = useMemo(
    () =>
      classNames("generic-drawer-header", {
        [topSectionClass]: !!topSectionClass
      }),
    [topSectionClass]
  );

  const drawerClasses = useMemo(
    () =>
      classNames("generic-drawer", `generic-drawer-${verticalTransition}`, {
        [`drawer-show-${verticalTransition}`]: isVisible,
        [`drawer-hide-${verticalTransition}`]: !isVisible,
        [className]: !!className
      }),
    [verticalTransition, isVisible, className]
  );

  const smartBannerDiv = ".responsive-wrapper";
  const isSmartBannerDivExist = useNonReactElementExist({
    elementToWatch: smartBannerDiv
  });

  useEffect(() => {
    let _drawerPaddingBottom;
    if (!isMobile) {
      _drawerPaddingBottom = 0;
    } else {
      _drawerPaddingBottom = isSmartBannerDivExist
        ? document.querySelector(smartBannerDiv)?.clientHeight + 50
        : 50;
    }
    if (isDisplayedButtonBar) {
      const navbarGap = "7.6rem";
      const navbarGapPxValue = navbarGap.includes("rem")
        ? navbarGap.split("rem")[0] * 10
        : 0;
      _drawerPaddingBottom += navbarGapPxValue;
    }
    setDrawerPaddingBottom(_drawerPaddingBottom);
  }, [isDisplayedButtonBar, isMobile, isSmartBannerDivExist]);

  return (
    <div ref={componentRef} className={drawerClasses}>
      <div className={headerClasses}>{header}</div>
      <div
        className="generic-drawer-content"
        style={{ paddingBottom: `${drawerPaddingBottom}px` }}
      >
        {children}
      </div>
    </div>
  );
};

GenericDrawer.propTypes = {
  children: PropTypes.node,
  header: PropTypes.node,
  className: PropTypes.string,
  isVisible: PropTypes.bool,
  menu: PropTypes.string.isRequired,
  componentRef: PropTypes.object,
  verticalTransition: PropTypes.string.isRequired
};

export default React.memo(GenericDrawer);
